import { ContentStyle } from '../../../../types/ContentStyle';
import { SE_CE_COPY } from './seCe';
import { VEEQO_COPY } from './veeqo';

export const copy = {
  [ContentStyle.SELLER_CENTRAL]: SE_CE_COPY,
  [ContentStyle.VEEQO]: VEEQO_COPY,
};
